<template>
  <router-view
    :bluredProp="bluredProp"
    :emailProp="email"
    :passwordProp="password"
    :repeatPasswordProp="repeatPassword"
    :phoneNumberProp="phoneNumber"
    :loading="loading"
    :capsOn="capsOn"
    @clearOthers="clearOthers"
    @updateEmail="updateEmail"
    @updatePass="updatePass"
    @updateRepeatPass="updateRepeatPass"
    @clearInputs="checkAnyInput"
    @isLoading="isLoading"
    @clearBluredPropLandingLayout="clearBluredPropLandingLayout"
    @isCapsOn="isCapsOn">
  </router-view>
</template>

<script>
  export default {
    name: 'LandingLayout',
    data() {
      return {
        bluredProp: '',
        email: '',
        password: '',
        repeatPassword: '',
        phoneNumber: '',
        loading: false,
        capsOn: false
      }
    },
    watch: {
      $route (to, from) {
        if (to.path !== from.path) {
          this.bluredProp = '';
          this.repeatPassword = '';
          this.loading = false;
          this.capsOn = false;
          if (to.name !== 'Reset' && to.name !== 'PhoneNumberVerification') {
            this.email = '';
          }
          if (to.name !== 'PhoneNumberVerification') {
            this.password = '';
          }
        }
      }
    },
    methods: {
      // Update email prop from FPInputEmail > parent > LandingLayout
      updateEmail (val) {
        this.email = val
      },
      // Update password prop from FPInputPass, FPInputNewRepeatPass > parent > LandingLayout
      updatePass (val) {
        this.password = val
      },
      // Update password prop from FPInputNewRepeatPass > parent > LandingLayout
      updateRepeatPass (val) {
        this.repeatPassword = val
      },
      // Update phone number prop from parent > LandingLayout
      updatePhoneNumber (val) {
        this.phoneNumber = val
      },
      // Update loading prop from FPInputButton > parent > LandingLayout
      isLoading (val) {
        this.loading = val
      },
      // Upon focusing on input field remove the error from selected input
      // and use that passed prop
      clearOthers(e) {
        this.bluredProp = e.target.name
      },
      // Upon submiting form if there are any errors just remove the tooltip
      // FPInputButton > parent ( onSubmit... ) > LandingLayout
      checkAnyInput() {
        this.bluredProp = ''
      },
      // When we have error in custom component ( email, pass ), we have overlap
      // with bluredPropChild and bluredProp. We listen the emit from Register ( direct child )
      // and reset the bluredProp we are sending to FPInputNewRepeatPass
      clearBluredPropLandingLayout () {
        this.checkAnyInput()
      },
      // Handle CapsLock
      isCapsOn (val) {
        this.capsOn = val
      }
    }
  }
</script>

<style lang="scss">
  @import '@/scss/import-landing-layout.scss';
</style>
